import React from 'react';

const Blog = () => {
    return (
        <div>
            <div>
                <h1>what is context api?</h1>
                <p>The Context API is a React structure that enables you to exchange unique details.
                    And it assists in solving prop-drilling from all levels of your application.
                    it allows prop-drilling, and a unique data can be passed bettwen 2 component.</p>
            </div>
            <div>
                <h1>What is semantics tag</h1>
                <p>
                Semantic HTML tags adds meaning to your markup. it allows search engines, screen readers, and web browsers to read the dom.
                Semantic HTML tags let you serve structured content to your users, which is especially important for on-page 
                SEO and accessibility.
                </p>
            </div>
        </div>
    );
};

export default Blog;